import type { Route } from '~/core/router'

import * as libraryFavoritesMovies from '~/routes/library/favorites/movies'
import * as libraryFavoritesTvChannels from '~/routes/library/favorites/tvChannels'
import * as libraryFavoritesTvShows from '~/routes/library/favorites/tvShows'
import * as libraryPurchasedLiveEvents from '~/routes/library/purchased/liveEvents'
import * as libraryPurchasedMovies from '~/routes/library/purchased/movies'
import * as libraryPurchasedTvChannels from '~/routes/library/purchased/tvChannels'
import * as libraryPurchasedTvShows from '~/routes/library/purchased/tvShows'
import * as libraryRoot from '~/routes/library/root'

export const route: Route = {
  children: [
    {
      path: '',
      component: [libraryRoot.LibraryPage],
      init: libraryRoot.model.initLibraryPage,
      left: libraryRoot.model.leftLibraryPage,
    },
    {
      path: '/favorites/tv',
      component: [libraryFavoritesTvChannels.LibraryFavoritesTvChannelsPage],
      init: libraryFavoritesTvChannels.model.initLibraryFavoritesTvChannelsPage,
      left: libraryFavoritesTvChannels.model.leftLibraryFavoritesTvChannelsPage,
    },
    {
      path: '/favorites/movies',
      component: [libraryFavoritesMovies.LibraryFavoritesMoviesPage],
      init: libraryFavoritesMovies.model.initLibraryFavoritesMoviesPage,
      left: libraryFavoritesMovies.model.leftLibraryFavoritesMoviesPage,
    },
    {
      path: '/favorites/shows',
      component: [libraryFavoritesTvShows.LibraryFavoritesTvShowsPage],
      init: libraryFavoritesTvShows.model.initLibraryFavoritesTvShowsPage,
      left: libraryFavoritesTvShows.model.leftLibraryFavoritesTvShowsPage,
    },
    {
      path: '/purchased/tv',
      component: [libraryPurchasedTvChannels.LibraryPurchasedTvChannelsPage],
      init: libraryPurchasedTvChannels.model.initLibraryPurchasedTvChannelsPage,
      left: libraryPurchasedTvChannels.model.leftLibraryPurchasedTvChannelsPage,
    },
    {
      path: '/purchased/movies',
      component: [libraryPurchasedMovies.LibraryPurchasedMoviesPage],
      init: libraryPurchasedMovies.model.initLibraryPurchasedMoviesPage,
      left: libraryPurchasedMovies.model.leftLibraryPurchasedMoviesPage,
    },
    {
      path: '/purchased/shows',
      component: [libraryPurchasedTvShows.LibraryPurchasedTvShowsPage],
      init: libraryPurchasedTvShows.model.initLibraryPurchasedTvShowsPage,
      left: libraryPurchasedTvShows.model.leftLibraryPurchasedTvShowsPage,
    },
    {
      path: '/purchased/events',
      component: [libraryPurchasedLiveEvents.LibraryPurchasedLiveEventsPage],
      init: libraryPurchasedLiveEvents.model.initLibraryPurchasedLiveEventsPage,
      left: libraryPurchasedLiveEvents.model.leftLibraryPurchasedLiveEventsPage,
    },
  ],
}
